<template>
	<el-dialog :title="$t('tts.title')" v-model="visible" width="600px" center @open="onOpen">
		<el-form :model="form" label-width="100px" ref="ttsForm">
			<el-form-item :label="$t('tts.text')" prop="text"
				:rules="[{ required: true, message: $t('tts.text_empty') }]">
				<el-input type="textarea" :rows="6" v-model="form.text"
					:placeholder="$t('tts.text_placeholder')"
					:show-word-limit="true" :maxlength="500"></el-input>
			</el-form-item>
			<el-form-item :label="$t('tts.voice')" prop="voice">
				<el-select v-model="form.voice" :placeholder="$t('tts.select_voice')">
					<el-option v-for="item in voiceOptions" :key="item.value"
						:label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('tts.format')" prop="format">
				<el-select v-model="form.format">
					<el-option label="MP3" value="mp3"></el-option>
					<el-option label="WAV" value="wav"></el-option>
					<el-option label="PCM" value="pcm"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="handleSynthesize" :loading="loading">
					{{ $t('tts.generate') }}
				</el-button>
			</el-form-item>
		</el-form>

		<div v-if="audioUrl" class="tts-result">
			<el-divider></el-divider>
			<div class="audio-wrapper">
				<audio :src="audioUrl" controls style="width: 100%"></audio>
			</div>
			<div class="url-wrapper">
				<el-input v-model="audioUrl" readonly>
					<template #append>
						<el-button @click="copyUrl">{{ $t('tts.copy') }}</el-button>
					</template>
				</el-input>
			</div>
		</div>

	</el-dialog>
</template>

<script>
	import tts from '@/model/tts'

	export default {
		name: 'TtsDialog',
		props: {
			modelValue: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				form: {
					text: '',
					voice: 'mary',
					format: 'mp3'
				},
				voiceOptions: [],
				loading: false,
				audioUrl: ''
			}
		},
		computed: {
			visible: {
				get() { return this.modelValue },
				set(val) { this.$emit('update:modelValue', val) }
			}
		},
		methods: {
			async onOpen() {
				this.form.text = '';
				this.audioUrl = '';
				if (this.voiceOptions.length === 0) {
					const res = await tts.voices()
					if (res.code === 200) {
						this.voiceOptions = res.data
					}
				}
			},
			async handleSynthesize() {
				this.$refs.ttsForm.validate(async (valid) => {
					if (!valid) return
					this.loading = true
					this.audioUrl = ''
					try {
						const res = await tts.synthesize(this.form)
						if (res.code === 200) {
							this.audioUrl = res.data.url
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					} finally {
						this.loading = false
					}
				})
			},
			copyUrl() {
				const input = document.createElement('input')
				input.value = this.audioUrl
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success(this.$t('tts.copy_success'))
			}
		}
	}
</script>

<style scoped>
	.tts-result {
		margin-top: 10px;
	}

	.audio-wrapper {
		margin-bottom: 15px;
	}

	.url-wrapper {
		margin-top: 10px;
	}
</style>
